import { __awaiter, __generator } from "tslib";
var formatDevice = function (device) {
    return device.deviceId ? { id: device.deviceId, value: device.label || device.deviceId } : null;
};
export var getDevices = function () { return __awaiter(void 0, void 0, void 0, function () {
    var mediaDevices, microphones, cameras, speakers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, navigator.mediaDevices.enumerateDevices()];
            case 1:
                mediaDevices = _a.sent();
                microphones = mediaDevices.filter(function (_a) {
                    var kind = _a.kind, deviceId = _a.deviceId;
                    return deviceId && kind === 'audioinput';
                }).map(formatDevice);
                cameras = mediaDevices.filter(function (_a) {
                    var kind = _a.kind, deviceId = _a.deviceId;
                    return deviceId && kind === 'videoinput';
                }).map(formatDevice);
                speakers = mediaDevices.filter(function (_a) {
                    var kind = _a.kind, deviceId = _a.deviceId;
                    return deviceId && kind === 'audiooutput';
                }).map(formatDevice);
                return [2 /*return*/, { cameras: cameras, microphones: microphones, speakers: speakers }];
        }
    });
}); };
export var onDevicesChanged = function (callback) {
    var onDeviceChange = function () { return getDevices().then(callback); };
    void onDeviceChange();
    try {
        navigator.mediaDevices.addEventListener('devicechange', onDeviceChange);
    }
    catch (e) {
        console.log(e);
        return function () { };
    }
    return function () { return navigator.mediaDevices.removeEventListener('devicechange', onDeviceChange); };
};
//# sourceMappingURL=media-permissions.js.map